// extracted by mini-css-extract-plugin
export default {"container":"Preload_container__KX2bC","preloaderImage":"Preload_preloaderImage__-i+2s","fade-text":"Preload_fade-text__3hH9U","visible":"Preload_visible__IyDl6"};